import { Texture } from "../resource/Texture";
import { Texture2D } from "../resource/Texture2D";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { ILaya } from "../../ILaya";
import { LayaEnv } from "../../LayaEnv";
import { Browser } from "../utils/Browser";
import { TransformKind } from "./SpriteConst";
import { Sprite } from "./Sprite";
import { Widget } from "../components/Widget";
export class OpenDataContextView extends Sprite {
    constructor() {
        super();
        this._fps = 30;
        this._width = this._height = 200;
        this._widget = Widget.EMPTY;
        let tex = new Texture(new Texture2D(this._width, this._height, TextureFormat.R8G8B8A8, false, false, true));
        tex.bitmap.lock = true;
        this.texture = tex;
    }
    get fps() {
        return this._fps;
    }
    set fps(value) {
        if (this._fps != value) {
            this._fps = value;
            if (LayaEnv.isPlaying && this.activeInHierarchy
                && window.wx && window.sharedCanvas) {
                ILaya.timer.clear(this, this._onLoop);
                ILaya.timer.loop(1000 / value, this, this._onLoop);
            }
        }
    }
    _onActive() {
        if (!LayaEnv.isPlaying)
            return;
        if (window.wx && window.sharedCanvas)
            ILaya.timer.loop(1000 / this._fps, this, this._onLoop);
    }
    _onInActive() {
        if (!LayaEnv.isPlaying)
            return;
        this.postMsg({ type: "close" });
        ILaya.timer.clear(this, this._onLoop);
    }
    get top() {
        return this._widget.top;
    }
    set top(value) {
        if (value != this._widget.top) {
            this._getWidget().top = value;
        }
    }
    get bottom() {
        return this._widget.bottom;
    }
    set bottom(value) {
        if (value != this._widget.bottom) {
            this._getWidget().bottom = value;
        }
    }
    get left() {
        return this._widget.left;
    }
    set left(value) {
        if (value != this._widget.left) {
            this._getWidget().left = value;
        }
    }
    get right() {
        return this._widget.right;
    }
    set right(value) {
        if (value != this._widget.right) {
            this._getWidget().right = value;
        }
    }
    get centerX() {
        return this._widget.centerX;
    }
    set centerX(value) {
        if (value != this._widget.centerX) {
            this._getWidget().centerX = value;
        }
    }
    get centerY() {
        return this._widget.centerY;
    }
    set centerY(value) {
        if (value != this._widget.centerY) {
            this._getWidget().centerY = value;
        }
    }
    _getWidget() {
        this._widget === Widget.EMPTY && (this._widget = this.addComponent(Widget));
        return this._widget;
    }
    _onLoop() {
        let tex = this.texture;
        let canvas = window.sharedCanvas;
        if (tex.width != canvas.width || tex.height != canvas.height) {
            tex.bitmap.destroy();
            tex.bitmap = new Texture2D(canvas.width, canvas.height, TextureFormat.R8G8B8A8, false, false, true, true);
            tex.bitmap.lock = true;
        }
        if (Browser.onMiniGame) {
            if (canvas.toTempFilePath) {
                tex.bitmap.setImageData(canvas, true, false);
            }
        }
        else
            tex.bitmap.setImageData(canvas, true, false);
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Size) != 0) {
            if (window.sharedCanvas) {
                window.sharedCanvas.width = this._width;
                window.sharedCanvas.height = this._height;
            }
            if (this._widget !== Widget.EMPTY)
                this._widget.resetLayout();
            this.callLater(this.updateViewPort);
        }
        if ((kind & TransformKind.Pos) != 0)
            this.callLater(this.updateViewPort);
    }
    updateViewPort() {
        let stage = ILaya.stage;
        let sx = stage._canvasTransform.getScaleX() * this.globalScaleX * stage.transform.getScaleX();
        let sy = stage._canvasTransform.getScaleY() * this.globalScaleY * stage.transform.getScaleY();
        this.postMsg({
            type: "updateViewPort",
            box: {
                x: this.x * sx,
                y: this.y * sy,
                width: this.width * sx,
                height: this.height * sy,
            }
        });
    }
    postMsg(msg) {
        if (window.wx && window.wx.getOpenDataContext) {
            var openDataContext = window.wx.getOpenDataContext();
            openDataContext.postMessage(msg);
        }
    }
}
